import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, Row, Col, Button, Dropdown } from 'react-bootstrap';
import AdminNavbar from '../../Pages/Navbar/AdminNavbar';
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl';

function ReportedJobView() {
    const navigate = useNavigate();
    const { jobId } = useParams();
    const [job, setJob] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [status, setStatus] = useState('');

    useEffect(() => {
        const fetchJobDetails = async () => {
            try {
                const response = await fetch(`${BaseUrl}/api/employer/${jobId}`);
                if (!response.ok) {
                    throw new Error('Failed to fetch job details');
                }
                const data = await response.json();
                
                // Parse array fields that might be stored as JSON strings
                const parsedData = {
                    ...data,
                    preferred_candidates_country: safeParseArray(data.preferred_candidates_country),
                    candidates_country_experience: safeParseArray(data.candidates_country_experience),
                    main_skills: safeParseArray(data.main_skills),
                    cooking_skills: safeParseArray(data.cooking_skills),
                    other_skills: safeParseArray(data.other_skills),
                    preferred_years_of_experience: safeParseArray(data.preferred_years_of_experience),
                    offer_for_selected_candidates: safeParseArray(data.offer_for_selected_candidates),
                    preferred_language_for_worker: safeParseArray(data.preferred_language_for_worker),
                    profile_photo_url: data.profile_photo 
                        ? `${BaseUrl}${data.profile_photo}`
                        : null
                };
                
                setJob(parsedData);
                setStatus(parsedData.status || '');
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchJobDetails();
    }, [jobId]);

    const safeParseArray = (value) => {
        try {
            if (!value) return [];
            if (Array.isArray(value)) return value;
            return JSON.parse(value);
        } catch (e) {
            return [];
        }
    };

    const handleBack = () => {
        navigate('/reportedjob');
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    const updateJobStatus = async (newStatus) => {
        try {
            const response = await fetch(`${BaseUrl}/api/employer/${jobId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    status: newStatus
                })
            });

            if (!response.ok) {
                throw new Error('Failed to update job status');
            }

            setStatus(newStatus);
            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: `Job status updated to ${newStatus}`,
                timer: 2000,
                showConfirmButton: false
            });
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Error!',
                text: err.message,
                timer: 2000,
                showConfirmButton: false
            });
        }
    };

    const handleRemoveDelete = async () => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "This will remove/delete the job!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, remove it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${BaseUrl}/api/employer/${jobId}`, {
                    method: 'DELETE'
                });

                if (!response.ok) {
                    throw new Error('Failed to delete job');
                }

                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'Job has been removed/deleted.',
                    timer: 2000,
                    showConfirmButton: false
                }).then(() => {
                    navigate('/reportedjob');
                });
            } catch (err) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: err.message,
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        }
    };

    if (loading) {
        return (
            <>
                <AdminNavbar />
                <div className="text-center mt-5" style={{ marginTop: '100px' }}>
                    Loading...
                </div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <AdminNavbar />
                <div className="text-center mt-5" style={{ marginTop: '100px' }}>
                    <div className="text-center">Error: {error}</div>
                    <button
                        className="btn btn-outline-secondary mt-3"
                        onClick={handleBack}
                    >
                        Back to List
                    </button>
                </div>
            </>
        );
    }

    if (!job) {
        return (
            <>
                <AdminNavbar />
                <div className="text-center mt-5" style={{ marginTop: '100px' }}>
                    <div className="text-center">Job details not found</div>
                    <button
                        className="btn btn-outline-secondary mt-3"
                        onClick={handleBack}
                    >
                        Back to List
                    </button>
                </div>
            </>
        );
    }

    return (
        <>
            <AdminNavbar />
            <section className="agency blog blog-sec blog-sidebar pb-5 blog-list sider" style={{ marginTop: '80px' }}>
                <Container>
                    <Row>
                        <Col md={12} lg={12} className="pe-lg-4">
                            <div className="product-wrapper-grid list-view">
                                <Row>
                                    <Col xs={12} className="col-12_padding_Set">
                                        <div className="agency-box position-relative">
                                            <div className="agency-header-container">
                                                <picture>
                                                    <source media="(max-width:576px)" srcSet="https://cdn.helperplace.com/front-app/assets/images/misc/5-sm.webp" />
                                                    <source media="(max-width:768px)" srcSet="https://cdn.helperplace.com/front-app/assets/images/misc/5-md.webp" />
                                                    <img
                                                        src="https://cdn.helperplace.com/front-app/assets/images/misc/5.jpg"
                                                        alt="Header"
                                                        className="agency_header"
                                                    />
                                                </picture>
                                                <div className="agency_header_White_opcity"></div>

                                                <div className="profile-section">
                                                    <div className="profile-image-wrapper">
                                                        <img
                                                            src={job.profile_photo_url || '/fallback-user.png'}
                                                            alt="Profile"
                                                            className="profile-image"
                                                        />
                                                    </div>

                                                    <div className="badge-group">
                                                        <label className="label_blue">
                                                            {job.posted_by?.toLowerCase().includes('direct') ? 'Direct' : 'Agency'}
                                                        </label>
                                                        <span className="top-active">Very Active</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="product-box">
                                                <h1 className="mb-0 listing-about-title p-0" style={{ wordBreak: 'break-word' }}>
                                                    {job.job_title}
                                                </h1>
                                                <div className="hp-candidate-wrapper">
                                                    <div>
                                                        <p className="mb-2 p-0 text-left listing-about-sub-title">
                                                            {job.adults || 'N/A'} adults + {job.children || 'N/A'} kids | {job.nationality || 'N/A'}
                                                            <span> | Posted: {formatDate(job.posted_on || job.created_at)} </span>
                                                        </p>
                                                    </div>
                                                    <div className="apply-btn" style={{display:'flex'}}>
                                                        <Button
                                                            variant="secondary"
                                                            className="hp-cancel-btn" 
                                                            style={{ marginTop: '1px', marginLeft: '10px', width:'100px' }}
                                                            onClick={handleBack}
                                                        >
                                                            Back
                                                        </Button>
                                                        
                                                        {/* Actions Dropdown */}
                                                        <Dropdown style={{ display: 'inline-block', marginLeft: '10px', backgroundColor:'blue', color:'white', borderRadius: '0px' }}>
                                                            <Dropdown.Toggle variant="" id="dropdown-status" style={{color:'white'}}>
                                                                Actions
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item 
                                                                    onClick={() => updateJobStatus(status === 'Active' ? 'Inactive' : 'Active')}
                                                                >
                                                                    {status === 'Active' ? 'Make Inactive' : 'Make Active'}
                                                                </Dropdown.Item>
                                                                <Dropdown.Divider />
                                                                <Dropdown.Item 
                                                                    onClick={handleRemoveDelete}
                                                                    className="text-danger"
                                                                >
                                                                    Remove/Delete
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Rest of your existing JSX remains exactly the same */}
                                {/* Job Requirement Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Job Requirement</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col className="mx-auto">
                                        <Row className="ar">
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17">
                                                        <use height="14" width="14" href="https://www.helperplace.com/assets/icons/helperplace_all_icons.svg#user"></use>
                                                    </svg>
                                                    {job.domestic_worker_category || 'N/A'} <span> |</span>
                                                    <span> {job.job_type || 'N/A'} </span>
                                                </h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17">
                                                        <use height="14" width="14" href="https://www.helperplace.com/assets/icons/helperplace_all_icons.svg#calendar"></use>
                                                    </svg>
                                                    Start Before: {formatDate(job.job_starting_date)}
                                                </h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17">
                                                        <use height="14" width="14" href="https://www.helperplace.com/assets/icons/helperplace_all_icons.svg#map"></use>
                                                    </svg>
                                                    {job.working_city || 'N/A'}, {job.state_or_province || 'N/A'}
                                                </h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17">
                                                        <use height="16" width="16" href="https://www.helperplace.com/assets/icons/helperplace_all_icons.svg#file"></use>
                                                    </svg>
                                                    Contract Status: {job.prefer_contract_status || 'N/A'}
                                                </h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17">
                                                        <use height="16" width="16" href="https://www.helperplace.com/assets/icons/helperplace_all_icons.svg#bed-person"></use>
                                                    </svg>
                                                    Accommodation: {job.type_of_house || 'N/A'} ({job.rooms || 'N/A'} rooms)
                                                </h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17">
                                                        <use height="15" width="15" href="https://www.helperplace.com/assets/icons/helperplace_all_icons.svg#day_off"></use>
                                                    </svg>
                                                    Salary: {job.minimum_monthly_salary || 'N/A'} - {job.maximum_monthly_salary || 'N/A'} {job.country_currency || ''}
                                                    {job.negotiable ? ' (Negotiable)' : ''}
                                                </h3>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                {/* Job Description Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Job Description</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mx-auto mt-3 jOb_description description_tag ar">
                                        <div style={{ wordBreak: 'break-word' }}>
                                            {job.job_description || 'No description provided'}
                                        </div>
                                    </Col>
                                </Row>

                                {/* Required Skills Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Required Skills / Duties</h2>
                                    </Col>
                                </Row>
                                <Row className="yoga mt-3 event">
                                    {/* Language Skills */}
                                    <Col className="ar">
                                        <div className="col-11 phone_pedding mx-auto">
                                            <div className="event-container event-container_footer_margin_custom d-flex">
                                                <div className="yoga-circle">
                                                    <picture>
                                                        <source width="35px" height="35px" media="(max-width:992px)" srcSet="https://cdn.helperplace.com/skill_cat/1_1599642484.webp" />
                                                        <img width="40px" height="40px" src="https://cdn.helperplace.com/skill_cat/1_1599642484.webp" alt="Language skills" />
                                                    </picture>
                                                </div>
                                                <div className="event-info">
                                                    <h3 className="primary ar"> Language: </h3>
                                                    {job.preferred_language_for_worker?.length > 0 ? (
                                                        job.preferred_language_for_worker.map((lang, index) => (
                                                            <h4 key={index} className="float-left float-left-ar color_1"> {lang} </h4>
                                                        ))
                                                    ) : (
                                                        <h4 className="float-left float-left-ar color_1">N/A</h4>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                    {/* Main Skills */}
                                    <Col xs={11} className="ar">
                                        <div className="col-11 phone_pedding mx-auto">
                                            <div className="event-container event-container_footer_margin_custom d-flex">
                                                <div className="yoga-circle">
                                                    <picture>
                                                        <source width="35px" height="35px" media="(max-width:992px)" srcSet="https://cdn.helperplace.com/skill_cat/4_1599643968.webp" />
                                                        <img width="40px" height="40px" src="https://cdn.helperplace.com/skill_cat/4_1599643968.webp" alt="Main skills" />
                                                    </picture>
                                                </div>
                                                <div className="event-info">
                                                    <h3 className="primary ar"> Main Skills: </h3>
                                                    {job.main_skills?.length > 0 ? (
                                                        job.main_skills.map((skill, index) => (
                                                            <h4 key={index} className="float-left float-left-ar color_2"> {skill} </h4>
                                                        ))
                                                    ) : (
                                                        <h4 className="float-left float-left-ar color_2">N/A</h4>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                    {/* Cooking Skills */}
                                    <Col xs={11} className="ar">
                                        <div className="col-11 phone_pedding mx-auto">
                                            <div className="event-container event-container_footer_margin_custom d-flex">
                                                <div className="yoga-circle">
                                                    <picture>
                                                        <source width="35px" height="35px" media="(max-width:992px)" srcSet="https://cdn.helperplace.com/skill_cat/2_1599644151.webp" />
                                                        <img width="40px" height="40px" src="https://cdn.helperplace.com/skill_cat/2_1599644151.webp" alt="Cooking skills" />
                                                    </picture>
                                                </div>
                                                <div className="event-info">
                                                    <h3 className="primary ar"> Cooking Skills: </h3>
                                                    {job.cooking_skills?.length > 0 ? (
                                                        job.cooking_skills.map((skill, index) => (
                                                            <h4 key={index} className="float-left float-left-ar color_3"> {skill} </h4>
                                                        ))
                                                    ) : (
                                                        <h4 className="float-left float-left-ar color_3">N/A</h4>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>

                                    {/* Other Skills */}
                                    <Col xs={11} className="ar">
                                        <div className="col-11 phone_pedding mx-auto">
                                            <div className="event-container event-container_footer_margin_custom d-flex">
                                                <div className="yoga-circle">
                                                    <picture>
                                                        <source width="35px" height="35px" media="(max-width:992px)" srcSet="https://cdn.helperplace.com/skill_cat/3_1599642528.webp" />
                                                        <img width="40px" height="40px" src="https://cdn.helperplace.com/skill_cat/3_1599642528.webp" alt="Other skills" />
                                                    </picture>
                                                </div>
                                                <div className="event-info">
                                                    <h3 className="primary ar"> Other Skills: </h3>
                                                    {job.other_skills?.length > 0 ? (
                                                        job.other_skills.map((skill, index) => (
                                                            <h4 key={index} className="float-left float-left-ar color_4"> {skill} </h4>
                                                        ))
                                                    ) : (
                                                        <h4 className="float-left float-left-ar color_4">N/A</h4>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default ReportedJobView;
